// Resize handle and project chip chrome for scheduled time-grid tasks.
import { Box } from '@mui/material';
import TagChip from '@/components/ui/TagChip';
import { buildTaskRowTrailingSx } from '@/components/ui/buildTaskRowTitleTrailingSx';
import { getOnboardingHighlightSx } from '@/features/onboarding/utils/onboardingHighlightSx';
import { abbreviateProjectDisplayName } from '@/features/tasks/utils/ui/projectPillAbbreviation';

export const renderScheduledTaskResizeHandle = (
  handleMouseDown,
  onboardingHighlight = false,
) => (
  <Box
    className="task-resize-handle"
    onMouseDown={(e) => {
      e.stopPropagation();
      handleMouseDown(e);
    }}
    data-no-dnd="true"
    data-testid="task-resize-handle"
    data-resize-handle="compact"
    sx={{
      ...getOnboardingHighlightSx(onboardingHighlight),
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: 40,
      height: 10,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      pb: '1px',
      cursor: 'ns-resize',
      zIndex: 4,
      opacity: 0.45,
      '&::after': {
        content: '""',
        width: 22,
        height: 4,
        borderRadius: '2px',
        bgcolor: 'grey.500',
      },
    }}
  />
);

export const renderScheduledTaskProjectChip = (
  primaryProject,
  projectDisplayMap,
  displayTier = 'full',
) => {
  const fullName =
    projectDisplayMap.get(primaryProject?.toLowerCase()) ?? primaryProject;
  const visibleLabel =
    displayTier === 'abbrev'
      ? abbreviateProjectDisplayName(fullName)
      : displayTier === 'dot'
        ? ''
        : fullName;

  return (
    <Box
      data-testid="scheduled-task-project-chip-wrap"
      data-project-pill-tier={displayTier}
      sx={buildTaskRowTrailingSx({ marginLeftAuto: true })}
    >
      <TagChip
        tag={primaryProject}
        label={visibleLabel}
        aria-label={fullName}
        dense
        listRowProjectPill
        projectDisplayTier={displayTier}
        data-testid="scheduled-task-project-chip"
        data-project-pill-tier={displayTier}
      />
    </Box>
  );
};
